var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.366.366a1.25 1.25 0 0 1 1.768 0L8.8 7.033a1.25 1.25 0 0 1 0 1.767l-6.666 6.667a1.25 1.25 0 1 1-1.768-1.768L6.15 7.918.366 2.134a1.25 1.25 0 0 1 0-1.768Z"
  })));
};
export default SvgChevron;